export const environment = {
  production: true,
  version: '0f5583ac62',
  site_version: 'SITE_VERSION'
};
